// utils/token.js

const parseJwt = (token) => {
  try {
    const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const json = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(json);
  } catch {
    return null;
  }
};

export const isTokenExpired = (token, bufferSeconds = 60) => {
  if (!token) return true;
  const payload = parseJwt(token);
  if (!payload?.exp) return true;
  return payload.exp - bufferSeconds < Date.now() / 1000;
};

// ✅ NEW: Only returns true if token EXISTS and is expired
export const hasValidToken = (token) => {
  if (!token) return false;
  return !isTokenExpired(token, 60);
};
